import CompaniesDocuments from './CompaniesDocuments';

export default CompaniesDocuments;
